module.exports = __webpack_public_path__ + "img/environment-after.7c02a950.jpg";